import React from "react";
import PropTypes from "prop-types";

type TableLoadingShimmerProps = {
  rows: number
};

const TableLoadingShimmer: React.FC<TableLoadingShimmerProps> = ({ rows }) => {
  return <div className="tw-animate-pulse tw-overflow-x-auto">
    <div className="tw-overflow-hidden"></div>
    <table className="tw-w-full">
      <thead className="tw-bg-gray-50">
        <tr>
          <th className="tw-px-3 tw-py-5"><div className="tw-h-4 tw-w-16 tw-rounded tw-bg-gray-200"></div></th>
          <th className="tw-px-3 tw-py-5"><div className="tw-h-4 tw-w-16 tw-rounded tw-bg-gray-200"></div></th>
          <th className="tw-px-3 tw-py-5"><div className="tw-h-4 tw-w-16 tw-rounded tw-bg-gray-200"></div></th>
          <th className="tw-px-3 tw-py-5"><div className="tw-h-4 tw-w-16 tw-rounded tw-bg-gray-200"></div></th>
          <th className="tw-px-3 tw-py-5"><div className="tw-h-4 tw-w-16 tw-rounded tw-bg-gray-200"></div></th>
          <th className="tw-px-3 tw-py-5"><div className="tw-h-4 tw-w-16 tw-rounded tw-bg-gray-200"></div></th>
          <th className="tw-px-3 tw-py-5"><div className="tw-h-4 tw-w-16 tw-rounded tw-bg-gray-200"></div></th>
          <th className="tw-px-3 tw-py-5"><div className="tw-h-4 tw-w-16 tw-rounded tw-bg-gray-200"></div></th>
        </tr>
      </thead>
      <tbody>
        {
          Array.from(Array(rows)).map((_, i) => {
            return <tr key={`tr_TableLoadingShimmer_${i}`} className="hover:tw-bg-gray-50">
              <td className="tw-px-3 tw-py-4">
                <div className="tw-h-2 tw-w-16 tw-rounded tw-bg-gray-200"></div>
              </td>
              <td className="tw-px-3 tw-py-4">
                <div className="tw-h-2 tw-w-16 tw-rounded tw-bg-gray-200"></div>
              </td>
              <td className="tw-px-3 tw-py-4">
                <div className="tw-h-2 tw-w-16 tw-rounded tw-bg-gray-200"></div>
              </td>
              <td className="tw-px-3 tw-py-4">
                <div className="tw-h-2 tw-w-16 tw-rounded tw-bg-gray-200"></div>
              </td>
              <td className="tw-px-3 tw-py-4">
                <div className="tw-h-2 tw-w-16 tw-rounded tw-bg-gray-200"></div>
              </td>
              <td className="tw-px-3 tw-py-4">
                <div className="tw-h-2 tw-w-16 tw-rounded tw-bg-gray-200"></div>
              </td>
              <td className="tw-px-3 tw-py-4">
                <div className="tw-h-2 tw-w-16 tw-rounded tw-bg-gray-200"></div>
              </td>
              <td className="tw-px-3 tw-py-4">
                <div className="tw-h-2 tw-w-16 tw-rounded tw-bg-gray-200"></div>
              </td>
            </tr>
          })
        }

      </tbody>
    </table>
  </div>;
};

TableLoadingShimmer.propTypes = {
  rows: PropTypes.number.isRequired
};

export default TableLoadingShimmer;
